import type { ReactNode } from "react"

interface CommentaryPanelProps {
  children: ReactNode
  className?: string
}

/**
 * Full-width commentary band — dark stripe with thin gold neon rules top and bottom.
 * Content centered at max-w-2xl. Used for narration and dialogue — things the
 * broadcast desk *says*. No box, no PanelFrame.
 */
export function CommentaryPanel({
  children,
  className = "",
}: CommentaryPanelProps) {
  const gold = "oklch(0.85 0.28 85 / 0.3)"
  const glow = "oklch(0.85 0.28 85 / 0.15)"

  return (
    <div
      className={`relative ${className}`}
      style={{
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        background:
          "linear-gradient(180deg, oklch(0.06 0.01 55) 0%, oklch(0.08 0.012 55) 50%, oklch(0.06 0.01 55) 100%)",
      }}
    >
      {/* Top neon rule */}
      <div
        className="absolute top-0 right-0 left-0 h-px"
        style={{
          background: `linear-gradient(90deg, transparent 10%, ${gold} 30%, ${gold} 70%, transparent 90%)`,
          boxShadow: `0 0 6px ${glow}`,
        }}
      />
      {/* Bottom neon rule */}
      <div
        className="absolute right-0 bottom-0 left-0 h-px"
        style={{
          background: `linear-gradient(90deg, transparent 10%, ${gold} 30%, ${gold} 70%, transparent 90%)`,
          boxShadow: `0 0 6px ${glow}`,
        }}
      />

      <div className="mx-auto max-w-2xl space-y-4 px-4 py-8">{children}</div>
    </div>
  )
}
